import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  OutlinedInput,
  FormControl,
  MenuItem,
  Select
} from '@material-ui/core';

import { useCoolfoodContext } from './Store';
import { actions } from '../state/reducer';

import { i18n } from '../App';

import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  label: {
    marginTop: 24,
    marginBottom: 8,
    fontSize: 18
  },
  prefix: {
    fontWeight: 'bold',
    paddingRight: '4px',
    color: '#e53e51',
  }
}));

const NumberOfBeneficiaries = ({ previousAnswer, onChange, prefix }) => {
  // console.log('DRAW Number Of beneficiaries');

  const classes = useStyles();

  const [globalState, globalDispatch] = useCoolfoodContext();

  const [answer, setAnswer] = useState({
    value: previousAnswer || globalState.numberOfBeneficiaries || 0
  });

  useEffect(() => {
    // const val =
    //   answer && answer.value
    //     ? answer.value
    //     : globalState.numberOfBeneficiaries;
    onChange('numberOfBeneficiaries', answer.value);
  }, [answer, answer.value, globalState.numberOfBeneficiaries, onChange]);

  const personLabel = i18n._('personne');
  const personsLabel = i18n._('personnes');

  let options = [1, 2, 3, 4, 5, 6, 7, 8, 9].map(num => {
    return (num > 1) ? { label: `${num} ${personsLabel}`, value: num } : { label: `${num} ${personLabel}`, value: num };
  });

  options = [{ label: i18n._('Votre réponse'), value: 0 }, ...options];

  const setSelection = (event, data) => {
    // Find option
    const answer = options.find(opt => opt.value === event.target.value);
    // Store number of beneficiaries in state
    globalDispatch({
      type: actions.SET_NUMBER_OF_BENEFICIARIES,
      data: answer.value
    });
    // Set answer
    setAnswer(answer);
  };

  return (
    <div className="numberOfBeneficiaries">
      <div className={classes.label}>
        <span className={classes.prefix}>{prefix}</span>{i18n._('Combien de membres de votre foyer engagez-vous ?')}
      </div>
      <FormControl required>
        <Select
          value={answer.value}
          onChange={setSelection}
          name="numberOfBeneficiaries"
          variant="outlined"
          input={<OutlinedInput />}
        >
          {options.map(opt => (
            <MenuItem key={`nbb_${opt.value}`} value={opt.value}>
              {opt.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
};

NumberOfBeneficiaries.propTypes = {
  previousAnswer: PropTypes.number
};

export default NumberOfBeneficiaries;
